import { render } from "./JModalContentCOIItem.vue?vue&type=template&id=24b36b80"
import script from "./JModalContentCOIItem.vue?vue&type=script&lang=js"
export * from "./JModalContentCOIItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__